import { render, staticRenderFns } from "./WindowUploader.vue?vue&type=template&id=3bf65032&scoped=true"
import script from "./WindowUploader.vue?vue&type=script&lang=js"
export * from "./WindowUploader.vue?vue&type=script&lang=js"
import style0 from "./WindowUploader.vue?vue&type=style&index=0&id=3bf65032&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf65032",
  null
  
)

export default component.exports